class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector("[data-swiper='marquee']"), {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 20,
      speed: 16000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }
}

customElements.define("announcement-bar", AnnouncementBar);
